import { compoudingAccionesRoles } from '../../acciones-roles/departamentos/compouding-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const CompoundingRoutes: SideBarButton = {
  data: {
    name: 'Mezclado',
    appendUrl: './compounding',
    roles: compoudingAccionesRoles.sideNavActions.main,
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Proceso',
        url: '/scheduling/mixing-mill',
        roles: compoudingAccionesRoles.sharedActions.schedulingMixingMill,
        otherUniqueUrls: [
          '/scheduling/preformas',
          '/scheduling/extruder',
          '/scheduling/calender',
        ],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Extrusion',
        url: '/scheduling/extrusion',
        roles: compoudingAccionesRoles.sharedActions.schedulingExtrusion,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Validacion',
        url: '/validation',
        roles: compoudingAccionesRoles.sharedActions.validation,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Work Orders',
        url: '/work-order-info',
        roles: compoudingAccionesRoles.sharedActions.workOrderInfo,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Etiquetas',
        url: '/packing-box',
        roles: compoudingAccionesRoles.sharedActions.packingBox,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Agregar datos QC',
        url: '/qc-data',
        roles: compoudingAccionesRoles.sharedActions.qcData,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Reporte Power BI',
        overWriteUrl: './reportsPBI/compounding',
        roles: compoudingAccionesRoles.sideNavActions.reportsPbiCompounding,
      },
      options: PreConfigButton3,
    },
  ],
};
